<button (click)="processAction(menuItem)" [disabled]="menuItem.disabled" mat-menu-item *ngIf="!menuItem.disabled">
  <mat-icon>
    {{ menuItem.iconLeft }}
  </mat-icon>
  <span>
    {{ menuItem.label | translate }}
  </span>
</button>
